import { OrganizationDTO, UserDTO, UserRoleName } from 'models'
import { noImageAvatar } from 'utilities'

interface AuthPayload {
  jwt: {
    accessToken: string;
    tokenType: string;
  };
  userDetails: UserDTO;
}

// const payload = {
//   jwt: {
//     accessToken: 'jwttoken',
//     tokenType: 'Bearer'
//   },
//   userDetails: {
//     roles: []
//   }
// };

export class User {
  static authenticate (payload: AuthPayload) {
    const { jwt, userDetails } = payload
    window.localStorage.setItem('jwt', JSON.stringify(jwt))
    this.setUserDetails(userDetails)
  }

  static setUserDetails (userDetails: UserDTO) {
    window.localStorage.setItem('userDetails', JSON.stringify(userDetails))
  }

  static isAuthenticated () {
    return window.localStorage.getItem('jwt') !== null
  }

  static isAdmin () {
    const index = this.getRoles()
      .findIndex((role: any) => role.name === UserRoleName.SUPER_ADMIN)
    return index > -1
  }

  static deauthenticate () {
    // window.localStorage.removeItem('jwt')
    // window.localStorage.removeItem('userDetails')
    window.localStorage.clear()
  }

  static getToken () {
    const jwt = window.localStorage.getItem('jwt')
    return jwt ? JSON.parse(jwt) : {}
  }

  static getDetails (): UserDTO {
    const userJson = window.localStorage.getItem('userDetails')
    if (userJson) {
      return JSON.parse(userJson)
    }

    return {} as UserDTO
  }

  static getId () {
    const { id } = this.getDetails()
    return id || null
  }

  static getRoles () {
    const { roles } = this.getDetails()
    return roles || []
  }

  static getOrganizations (): OrganizationDTO[] {
    const { organizations } = this.getDetails()
    return organizations || []
  }

  static get imageUrl (): string {
    const { imageUrl } = this.getDetails()
    return imageUrl || noImageAvatar
  }

  static get fullName (): string {
    const { firstName, lastName } = this.getDetails()
    return `${firstName || ''} ${lastName || ''}`
  }

  static get organization (): OrganizationDTO {
    const organizations = this.getOrganizations()
    if (!organizations || !organizations.length) return null

    return organizations[0]
  }

  static get userRoleNames (): UserRoleName[] {
    return this.getRoles().map(({ name }) => name)
  }

  static get areAllDashboardComponentsVisible (): boolean {
    return this.getRoles()
      .map(role => role.name)
      .some(roleName => ![
        UserRoleName.VIEWER,
        UserRoleName.OPERATOR_USER,
        UserRoleName.VIEW_PRODUCT_OWNER
      ].includes(roleName))
  }

  static isViewer (): boolean {
    const index = this.getRoles()
      .findIndex((role) => role.name === UserRoleName.VIEWER)
    return index > -1
  }

  static isOperatorUser (): boolean {
    const index = this.getRoles()
      .findIndex((role: any) => role.name === UserRoleName.OPERATOR_USER)
    return index > -1
  }

  static isShopOwner (): boolean {
    const index = this.getRoles()
      .findIndex((role: any) => role.name === UserRoleName.VIEW_PRODUCT_OWNER)
    return index > -1
  }

  static isManager (): boolean {
    const index = this.getRoles()
      .findIndex((role: any) => role.name === UserRoleName.PROJECT_MANAGER ||
        role.name === UserRoleName.DEPARTMENT_MANAGER)
    return index > -1
  }
}
